import {Component, OnInit, ViewChild} from '@angular/core';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {interval} from 'rxjs';

export interface Email {
  id: string;
  itemName: string;
}

@Component({
  selector: 'app-journey-analytics',
  templateUrl: './journey-analytics.component.html',
  styleUrls: ['./journey-analytics.component.scss']
})

export class JourneyAnalyticsComponent implements OnInit {
  componentLoading = true;

  constructor(public platform: LeftpanelComponent) {

  }

  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }

    const permissionSubscription = interval(500).subscribe((async x => {
      this.componentLoading = false;
      permissionSubscription.unsubscribe();
    }));
  }


}
